import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";

const ClickWrapper = ({ id, href, onClick, children }) => {
  const { asPath } = useRouter();

  if (onClick) {
    return (
      <div className="w-100" onClick={() => onClick(id)}>
        {children}
      </div>
    );
  } else if (id) {
    const destination = href || `${asPath}/${id}`;

    return <Link href={destination}>{children}</Link>;
  } else {
    return children;
  }
};

export default ClickWrapper;
